import $ from 'jquery';
import 'slick-carousel';
import Modal from './vendor/modal';
import FastClick from 'fastclick';
import Pikaday from 'pikaday';
import Tooltip from './vendor/tooltip';
import Chart from 'chart.js';
require('fancybox')($);

$(document)
    .on('click', '.page-sidebar-list .has-subitems > a', e => {
        e.preventDefault();

        let $this = $(e.target).closest('li');
        $this.find('ul').toggle();
    })
    .on('click', '.user-profile-logout', e => {
        if (confirm('Вы действительно хотите выйти?') === false) {
            e.preventDefault();
        }
    })
    .on('click', '.confirm-remove', e => {
        if (confirm('Вы действительно хотите удалить объект?') === false) {
            e.preventDefault();
        }

        let $target = $(e.target);
        $.ajax({
            method: 'POST',
            url: $target.attr('href'),
            success: data => window.location.reload()
        });
    })
    .on('click', '.mmodal', e => {
        e.preventDefault();
        let $target = $(e.target).closest('a');
        return new Modal($target, {
            width: $target.data('width')
        });
    })
    .on('click', '.poll-submit', e => {
        e.preventDefault();
        let $target = $(e.target),
            $form = $target.closest('form');

        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serialize(),
            success: data => {
                $('.poll-container').replaceWith(data);
            }
        })
    })
    .on('change', 'select.tab-list', e => {
        let $target = $(e.target).closest('select');
        $('.tab-content').removeClass('active').eq($target.get(0).selectedIndex).addClass('active');
    })
    .on('click', '.tab-item', e => {
        let $target = $(e.target).closest('li');
        $('.tab-item').removeClass('active');
        $target.addClass('active');
        if ($target.find('a').attr('href') == '#') {
            e.preventDefault();
            $('.tab-content').removeClass('active').eq($target.index()).addClass('active');
        }
    })
    .on('click', '.comment-reply', e => {
        e.preventDefault();
        let $target = $(e.target);
        $('#CommentForm_parent').val($target.attr('data-id'));
        let form = $('#comment-form');
        form.detach();
        form.appendTo($target.closest('.comment-item'));
    })
    .on('click', '.menu-link', e => {
        e.preventDefault();
        $('body').addClass('off-canvas-active');
    })
    .on('click', '.exit-off-canvas', e => {
        e.preventDefault();
        $('body').removeClass('off-canvas-active');
    });

    /*
    .on('click', '.left-off-canvas-menu ul li:not(.active).has-subitems a', e => {
        e.preventDefault();
        let $this = $(e.target);
        $this.closest('ul').find('li').removeClass('active');
        $this.closest('li').addClass('active');
    })
    .on('click', '.left-off-canvas-menu ul .active a', e => {
        e.preventDefault();
        let $this = $(e.target);
        $this.closest('ul').find('li').removeClass('active');
    });
    */

$(() => {
    FastClick.attach(document.body);

    $("a[href$='.jpg'],a[href$='.png'],a[href$='.gif']").attr('rel', 'gallery').fancybox({
        padding: 0,
        margin: [40, 0, 40, 0]
    });

    let pickerSettings = {
            firstDay: 1,
            format: 'DD.MM.YYYY',
            i18n: {
                previousMonth: 'Предыдущий месяц',
                nextMonth: 'Следующий месяц',
                months: [
                    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
                    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
                ],
                weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
            }
        },
        publishedFrom = new Pikaday({
            ...pickerSettings,
            field: document.getElementById('published_from')
        }),
        publishedTo = new Pikaday({
            ...pickerSettings,
            field: document.getElementById('published_to')
        });

    let syncIndexSidebarSliderHeight = () => {
        let $container = $('.index-container'),
            $slider = $container.find('.index-slider'),
            $indexSidebar = $container.find('.index-sidebar-list');
        $slider.find('.slider-item').height($indexSidebar.height());
    };

    if ($('body').hasClass('mobile') == false) {
        syncIndexSidebarSliderHeight();
        new Tooltip('[rel=tooltip]');
    }

    $('.slick-slider').slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 10000
    });

    let colors = ['#5CB5F7', '#BA25B1', '#7ED321', '#F5A623', '#F32A00'];

    let $charts = $('.chart');
    $charts.each((i, element) => {
        let dataId = $(element).attr('data-id'),
            jsonData = window.charts[dataId] || {};

        new Chart(element.getContext("2d")).Doughnut(jsonData, {
            segmentShowStroke: true,
            showTooltips: false,
            segmentStrokeColor: "#fff",
            segmentStrokeWidth: 2,
            percentageInnerCutout: 70, // This is 0 for Pie charts
            animationSteps: 100,
            animationEasing: "easeOutBounce",
            animateRotate: false,
            animateScale: false,
            legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span style=\"background-color:<%=segments[i].fillColor%>\"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>"
        });
    });
});


// WEBPACK FOOTER //
// ./src/index.js